export const FeesStepTestIds = {
  ROOT: 'prepare-disclosures-fees-step',
  BASELINE_NOTE: 'prepare-disclosures-fees-baseline-note',
  TOTALS_BAR: 'prepare-disclosures-fees-totals-bar',
  FEE_SECTIONS: 'prepare-disclosures-fees-sections',
  TOLERANCE_LEGEND: 'prepare-disclosures-fees-tolerance-legend',
  ORIGINATOR_CARD: 'prepare-disclosures-fees-originator-card',
};
